<template>
  <form @submit.prevent="discover">
    <slot name="title"></slot>
    <div class="relative w-full mt-6">
      <div class="pr-4">
        <route-location-selector
          :value="routeOptions.source_route"
          :bus-stops="mapRoutesForSelect"
          :findByLocationEnabled="
            user && (!routeBusStops || !routeBusStops.length)
          "
          label="from"
          placeholder="Enter pickup location"
          @location-selected="
            (location) => (routeOptions.source_route = location)
          "
        ></route-location-selector>
      </div>
      <div class="pr-4 mt-2">
        <route-location-selector
          :value="routeOptions.destination_route"
          :bus-stops="destinationBusStops"
          :findByLocationEnabled="
            user && (!routeBusStops || !routeBusStops.length)
          "
          label="to"
          placeholder="Enter destination location"
          @location-selected="
            (location) => (routeOptions.destination_route = location)
          "
        ></route-location-selector>
      </div>
      <div
        class="absolute inset-y-0 right-0 z-10 cursor-pointer"
        style="top: 30%"
      >
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          class="text-active"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="20"
            cy="20"
            r="19"
            class="fill-current stroke-current"
            stroke-width="2"
          />
          <path
            d="M20.7901 26.141L16.8199 29.8433L13.1176 25.8731"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M19.3934 15.3898L23.3636 11.6875L27.0659 15.6577"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M23.3637 11.6876L23.0511 20.6388"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M17.1325 20.892L16.8199 29.8432"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
    <div class="pr-4">
      <div
        class="
          flex
          items-center
          justify-between
          px-4
          py-3
          mt-4
          rounded
          input--neutral
        "
      >
        <div class="inline-flex items-center space-x-3">
          <div class="form-check">
            <input
              type="radio"
              id="one-way"
              class="form-check__input"
              value="one-way"
              v-model="routeOptions.route_type"
            />
            <label
              for="one-way"
              class="
                bg-white
                cursor-pointer
                form-check__input-label
                hover:border-active-blue
              "
            ></label>
          </div>
          <label
            for="one-way"
            class="
              ml-2
              text-xs
              font-medium
              cursor-pointer
              text-widget-form-radio-label
            "
            >One-way</label
          >
        </div>
        <div class="inline-flex items-center space-x-3" v-if="!routeBusStops">
          <div class="form-check">
            <input
              type="radio"
              id="return"
              class="form-check__input"
              value="return"
              v-model="routeOptions.route_type"
            />
            <label
              for="return"
              class="
                bg-white
                cursor-pointer
                form-check__input-label
                hover:border-active-blue
              "
            ></label>
          </div>
          <label
            for="return"
            class="
              ml-2
              text-xs
              font-medium
              cursor-pointer
              text-widget-form-radio-label
            "
            >Return</label
          >
        </div>
        <div class="inline-flex items-center space-x-3">
          <div class="form-check">
            <input
              type="radio"
              id="subscription"
              class="form-check__input"
              value="subscription"
              v-model="routeOptions.route_type"
            />
            <label
              for="subscription"
              class="
                bg-white
                cursor-pointer
                form-check__input-label
                hover:border-active-blue
              "
            ></label>
          </div>
          <label
            for="subscription"
            class="
              ml-2
              text-xs
              font-medium
              cursor-pointer
              text-widget-form-radio-label
            "
            >Subscribe</label
          >
        </div>
      </div>
    </div>
    <template v-if="isSubscription">
      <div
        class="my-4 mt-4 font-bold"
        :class="routeBusStops && routeBusStops.length ? 'sub_label' : ''"
      >
        Subscription settings
      </div>
      <div>
        <v-select
          v-model="routeOptions.subscription_route_type"
          :options="!routeBusStops ? bookingTypes : bookingTypesNoReturn"
          :reduce="(option) => option.id"
          placeholder="Booking Type"
        />
      </div>
      <div class="my-2">
        <flat-pickr
          v-model="routeOptions.departure_date"
          placeholder="Departure date"
          :config="{ minDate: 'today' }"
          class="
            block
            w-full
            h-full
            px-2
            py-2
            pr-8
            text-sm
            font-medium
            leading-tight
            rounded
            appearance-none
            text-neutral-type-1
            input--neutral
            focus:outline-none
          "
        ></flat-pickr>
      </div>
      <div class="my-2">
        <v-select
          multiple
          v-model="routeOptions.trip_days"
          :options="tripDays"
          :reduce="(day) => day.id"
          placeholder="Trip days (Days of the week)"
        >
          <template v-slot:option="option">
            <div class="flex items-center justify-between">
              <span>{{ option.label }}</span>
              <div
                class="
                  flex
                  items-center
                  justify-center
                  w-4
                  h-4
                  bg-green-300
                  rounded-full
                  bg-active-blue
                "
                v-if="routeOptions.trip_days.includes(option.id)"
              >
                <svg class="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                  <path
                    fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
              <div
                v-else
                class="w-4 h-4 bg-white border rounded-full border-active-blue"
              ></div>
            </div>
          </template>
        </v-select>
      </div>
      <div class="my-2">
        <v-select
          v-model="routeOptions.subscription_duration"
          :options="subscriptionDurations"
          :reduce="(option) => option.id"
          placeholder="Duration in weeks"
        />
      </div>
    </template>
    <template v-else>
      <div class="flex items-center pr-4 mt-4">
        <div class="w-1/2">
          <div class="font-bold text-center" v-show="isReturnTrip">
            First trip
          </div>
        </div>
        <div class="w-1/2">
          <div
            class="font-bold text-center"
            :class="isReturnTrip ? 'text-label' : 'text-label'"
            v-show="isReturnTrip"
          >
            Second trip
          </div>
        </div>
      </div>
      <div class="flex items-center mt-4">
        <div class :class="isReturnTrip ? 'w-1/2' : 'w-full'">
          <div class="relative inline-block w-full input--neutral">
            <flat-pickr
              v-model="routeOptions.departure_date"
              placeholder="Choose date"
              :config="{ minDate: 'today' }"
              class="
                block
                w-full
                h-full
                px-2
                py-2
                pr-8
                text-sm
                font-medium
                leading-tight
                rounded
                appearance-none
                text-neutral-type-1
                input--neutral
                focus:outline-none
                placeholder-neutral-type-1
              "
              required
            ></flat-pickr>
            <div
              class="
                absolute
                inset-y-0
                right-0
                flex
                items-center
                px-2
                pointer-events-none
              "
            >
              <svg
                class="w-6 h-6 fill-current grey-chevron"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                />
              </svg>
            </div>
          </div>
          <div class="flex items-center hidden mt-2">
            <div class="relative inline-block w-1/2 input--neutral">
              <select
                class="
                  block
                  w-full
                  h-full
                  px-4
                  py-2
                  pr-8
                  text-sm
                  font-medium
                  leading-tight
                  rounded
                  appearance-none
                  input--neutral
                  focus:outline-none
                "
              >
                <option>10</option>
              </select>
              <div
                class="
                  absolute
                  inset-y-0
                  right-0
                  flex
                  items-center
                  px-2
                  pointer-events-none
                "
              >
                <svg
                  class="w-6 h-6 fill-current"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path
                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                  />
                </svg>
              </div>
            </div>
            <div class="relative inline-block w-1/2 ml-2 input--neutral">
              <select
                class="
                  block
                  w-full
                  h-full
                  px-4
                  py-2
                  pr-8
                  text-sm
                  font-medium
                  leading-tight
                  rounded
                  appearance-none
                  input--neutral
                  focus:outline-none
                "
              >
                <option>30</option>
              </select>
              <div
                class="
                  absolute
                  inset-y-0
                  right-0
                  flex
                  items-center
                  px-2
                  pointer-events-none
                "
              >
                <svg
                  class="w-6 h-6 fill-current"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path
                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div class="w-1/2 ml-4" v-show="isReturnTrip">
          <div
            class="relative inline-block w-full input--neutral"
            :class="isReturnTrip ? '' : 'opacity-25'"
          >
            <flat-pickr
              v-model="routeOptions.return_date"
              placeholder="Choose date"
              :config="{ minDate: routeOptions.departure_date ? routeOptions.departure_date : 'today' }"
              class="block w-full h-full px-2 py-2 pr-8 text-sm font-medium leading-tight rounded appearance-none text-neutral-type-1 input--neutral focus:outline-none placeholder-neutral-type-1"
              :disabled="!isReturnTrip"
            ></flat-pickr>
            <div
              class="
                absolute
                inset-y-0
                right-0
                flex
                items-center
                px-2
                pointer-events-none
              "
            >
              <svg
                class="w-6 h-6 fill-current"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                />
              </svg>
            </div>
          </div>
          <div class="flex items-center hidden mt-2">
            <div class="relative inline-block w-1/2 opacity-25 input--neutral">
              <select
                class="
                  block
                  w-full
                  h-full
                  px-4
                  py-2
                  pr-8
                  text-sm
                  font-medium
                  leading-tight
                  rounded
                  opacity-25
                  appearance-none
                  input--neutral
                  focus:outline-none
                "
              >
                <option>10</option>
              </select>
              <div
                class="
                  absolute
                  inset-y-0
                  right-0
                  flex
                  items-center
                  px-2
                  pointer-events-none
                "
              >
                <svg
                  class="w-6 h-6 fill-current"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path
                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                  />
                </svg>
              </div>
            </div>
            <div
              class="relative inline-block w-1/2 ml-2 opacity-25 input--neutral"
            >
              <select
                class="
                  block
                  w-full
                  h-full
                  px-4
                  py-2
                  pr-8
                  text-sm
                  font-medium
                  leading-tight
                  rounded
                  opacity-25
                  appearance-none
                  input--neutral
                  focus:outline-none
                "
              >
                <option>30</option>
              </select>
              <div
                class="
                  absolute
                  inset-y-0
                  right-0
                  flex
                  items-center
                  px-2
                  pointer-events-none
                "
              >
                <svg
                  class="w-6 h-6 fill-current"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path
                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template v-if="isLuggage">
        <div class="w-full input--neutral luggage-toggle">
          <label
            class="relative inline-block w-1/2 text-sm dark-text luggage_label"
          >
            Add Luggage
          </label>
          <div class="luggage-config-group">
            <input
              type="button"
              value="-"
              class="luggage-action"
              @click="luggageValue > 1 ? (luggageValue = luggageValue - 1) : 1"
            />
            <input
              type="number"
              class="luggage-quantity"
              min="1"
              max="10"
              :value="luggageValue"
            />
            <input
              type="button"
              value="+"
              class="luggage-action"
              @click="
                luggageValue >= 0 && luggageValue < 10
                  ? (luggageValue = luggageValue + 1)
                  : luggageValue
              "
            />
          </div>
        </div>
      </template>
      <div class="mt-4">
        <div
          class="relative hidden inline-block w-full pb-2 input--neutral"
          style="height: 56px"
        >
          <select
            class="
              block
              w-full
              h-full
              px-4
              py-2
              pr-8
              text-sm
              font-bold
              leading-tight
              rounded
              appearance-none
              input--neutral
              focus:outline-none
            "
          >
            <option>1</option>
          </select>
          <div
            class="
              absolute
              inset-y-0
              right-0
              flex
              items-center
              px-2
              pointer-events-none
            "
          >
            <svg
              class="w-6 h-6 fill-current"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path
                d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
              />
            </svg>
          </div>
          <div
            class="absolute bottom-0 mb-1 ml-4 font-small text-label"
            style="font-size: 10px"
          >
            Boarding passengers
          </div>
        </div>
      </div>
    </template>
    <button
      type="submit"
      class="
        block
        w-full
        py-3
        mt-32
        font-bold
        text-center text-white
        rounded
        bg-active
        focus:outline-none
        find_btn
      "
      :disabled="processing"
    >
      {{
        processing
          ? "Processing..."
          : routeBusStops && routeBusStops.length
          ? "Initiate booking"
          : "Find tickets and prices"
      }}
    </button>
    <div
      class="comp_link"
      v-if="user && (!routeBusStops || !routeBusStops.length)"
    >
      <u><a :href="exploreRoutesUrl">view all available routes</a></u>
    </div>
    <div ref="map"></div>
  </form>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "@/services/axios";
import flatPickr from "vue-flatpickr-component";
import _ from "lodash";
import RouteLocationSelector from "./RouteLocationSelector.vue";

export default {
  props: {
    discoveryRequired: {
      type: Boolean,
      default: true,
    },
    routeBusStops: Array,
    walletSource: String,
    selectedItinerary: Object,
  },
  components: {
    flatPickr,
    RouteLocationSelector,
  },
  data() {
    return {
      processing: false,
      routeOptions: {
        source_route: null,
        destination_route: null,
        departure_date: "",
        return_date: "",
        route_type: "one-way",
        subscription_route_type: "",
        trip_days: [],
        subscription_duration: "",
        walletSource: "",
        payment_option: "",
      },
      isLuggage: false,
      luggageValue: 1,
      discoveredRoutes: {
        first_trip_routes: [],
        second_trip_routes: [],
      },
      bookingTypes: [
        { label: "One way", id: "one-way" },
        { label: "Return trip", id: "return" },
      ],
      bookingTypesNoReturn: [{ label: "One way", id: "one-way" }],
      tripDays: [
        { label: "Sunday", id: 1 },
        { label: "Monday", id: 2 },
        { label: "Tuesday", id: 3 },
        { label: "Wednesday", id: 4 },
        { label: "Thursday", id: 5 },
        { label: "Friday", id: 6 },
        { label: "Saturday", id: 7 },
      ],
      subscriptionDurations: [
        { label: "1 Week", id: "1" },
        { label: "2 Weeks", id: "2" },
        { label: "3 Weeks", id: "3" },
        { label: "4 Weeks", id: "4" },
      ],
      routeDestinationBusstops: [],
    };
  },
  created() {

    if (!this.busStops.length) {
      this.$store.dispatch("app/fetchBusStops");
    }

    if (this.$route.query.options) {
      const options = Object.fromEntries(
        new URLSearchParams(this.$route.query.options)
      );

      const source_route = options.source_route
        ? options.source_route.split("--")
        : null;
      const destination_route = options.destination_route
        ? options.destination_route.split("--")
        : null;

      this.routeOptions = {
        source_route: source_route
          ? { label: source_route[0], id: source_route[1] }
          : null,
        destination_route: destination_route
          ? { label: destination_route[0], id: destination_route[1] }
          : null,
        departure_date: options.departure_date || "",
        return_date: options.return_date || "",
        route_type: options.route_type || "one-way",
        subscription_route_type: options.subscription_route_type || "",
        trip_days: options.trip_days
          ? options.trip_days
              .split(",")
              .map(
                (day) =>
                  this.tripDays.find((item) => item.id === parseInt(day)).id
              )
          : [],
        subscription_duration: options.subscription_duration || "",
        payment_option: options.payment_option || "",
        walletSource: options.walletSource || "",
      };

      this.$nextTick(() => {
        this.discover();
      });
    }
  },
  watch: {
    "routeOptions.source_route"() {
      this.fetchRouteBusstops();
    },
    "routeOptions.departure_date"() {
      if(this.routeOptions.return_date && new Date(this.routeOptions.departure_date).getTime() > new Date(this.routeOptions.return_date).getTime()) {
        this.routeOptions.return_date = this.routeOptions.departure_date;
      }
    }
  },
  computed: {
    ...mapGetters("app", ["busStops"]),
    ...mapGetters("auth", ["user"]),
    exploreRoutesUrl() {
      return `${process.env.VUE_APP_WEBSITE_URL}/explore-routes`;
    },
    mapRoutesForSelect() {
      if (this.routeBusStops && this.routeBusStops.length) {
        return this.unique(this.routeBusStops);
      }
      return this.busStops.map((stop) => ({ ...stop, label: stop.location }));
    },
    destinationBusStops() {
      if (this.routeDestinationBusstops.length > 0) {
        return this.routeDestinationBusstops;
      }

      if (this.routeOptions.source_route) {
        if (this.routeOptions.source_route.is_autocomplete) {
          return this.mapRoutesForSelect;
        }

        if (this.mapRoutesForSelect.length > 0) {
          if (
            +this.routeOptions.source_route.id ===
            this.mapRoutesForSelect[this.mapRoutesForSelect.length - 1].id
          ) {
            return [
              this.mapRoutesForSelect[this.mapRoutesForSelect.length - 1],
            ];
          }
        }

        return this.mapRoutesForSelect.filter(
          (route) => +route.id > +this.routeOptions.source_route.id
        );
      }

      return [];
    },
    formValid() {
      if (!this.discoveryRequired) {
        return true;
      }

      const requiredFields = [
        "source_route",
        "destination_route",
        "route_type",
        "departure_date",
      ];

      return requiredFields.every((field) => !!this.routeOptions[field]);
    },
    isReturnTrip() {
      return (
        this.routeOptions.route_type === "return" ||
        this.routeOptions.subscription_route_type === "return"
      );
    },
    isSubscription() {
      return this.routeOptions.route_type === "subscription";
    },
  },
  methods: {
    unique(list) {
      if (list && list.length) {
        let data = _.uniqBy(list, "name");
        data = data.sort(function (a, b) {
          return a.id - b.id;
        });
        return data;
      }
    },
    discover() {
      if (!this.discoveryRequired) {
        return this.$emit("discovered", {});
      }

      if (
        this.routeOptions.route_type === "subscription" &&
        this.routeOptions.subscription_duration === ""
      ) {
        return this.$toast.error("Missing required fields");
      }

      if (this.processing || !this.formValid) {
        // don't execute this logic at the route catalogue section
        if (this.user && (!this.routeBusStops || !this.routeBusStops.length)) {
          this.$toast.error("Missing required fields");
        }
        return;
      }

      this.processing = true;

      this.$emit("discovering");

      let routes = [
        {
          source_id: this.routeOptions.source_route.id,
          destination_id: this.routeOptions.destination_route.id,
          key: "first_trip_routes",
        },
      ];

      if (this.isReturnTrip) {
        routes.push({
          source_id: this.routeOptions.destination_route.id,
          destination_id: this.routeOptions.source_route.id,
          key: "second_trip_routes",
        });
      }

      if (this.routeBusStops && this.routeBusStops.length) {
        this.processing = false;
        return this.$emit("discovered", {
          data: this.routeOptions,
        });
      }

      Promise.all(routes.map((route) => this.loadRoute(route)))
        .then(() => {
          this.$emit("discovered", {
            options: this.routeOptions,
            discoveredRoutes: this.discoveredRoutes,
            date_: this.routeOptions.departure_date,
            luggage_quantity: this.luggageValue,
          });

          this.addQueryParams();
        })
        .catch(() => {
          this.$emit("discovered", {
            options: this.routeOptions,
          });

          this.addQueryParams();
        })
        .finally(() => (this.processing = false));
    },
    loadRoute(route) {
      return axios
        .get(
          `route-discovery/from/${route.source_id}/to/${route.destination_id}`,
          {
            params: {
              tripDate: this.routeOptions.departure_date,
              // v2: 1
            },
          }
        )
        .then((res) => {
          this.discoveredRoutes[route.key] = res.data;
        });
    },
    addQueryParams() {
      const path = this.$route.name;
      const urlParams = new URLSearchParams({
        ...this.routeOptions,
        source_route: `${this.routeOptions.source_route.label}--${this.routeOptions.source_route.id}`,
        destination_route: `${this.routeOptions.destination_route.label}--${this.routeOptions.destination_route.id}`,
      }).toString();

      if (this.$route.name !== "home") {
        this.$router
          .push({
            name: path,
            query: { ...this.$route.query, options: urlParams },
          })
          .catch(() => {});
      }
    },
    fetchRouteBusstops() {
      this.routeDestinationBusstops = [];

      if (this.routeOptions.source_route.is_autocomplete) {
        return;
      }

      if (this.routeBusStops && this.routeBusStops.length) {
        return this.routeBusStops.map((stop) => ({
          ...stop,
          label: stop.location,
        }));
      }

      return axios
        .get(
          `/bus-stops?originBusStopName=${this.routeOptions.source_route.label}`
        )
        .then((res) => {
          this.routeDestinationBusstops = res.data.map((stop) => ({
            ...stop,
            label: stop.location,
          }));
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>

<style lang="scss">
.input--neutral {
  color: white;
}
.flatpickr-calendar {
  background-color: #ffffff !important;
  box-shadow: none !important;

  &.arrowTop:before,
  &.arrowTop:after {
    display: none;
  }
}

.flatpickr-weekday {
  color: #737d78 !important;
}

.flatpickr-day:not(.flatpickr-disabled) {
  font-weight: 500 !important;
}

.flatpickr-day {
  // color: theme('colors.widget-form-radio-label');
  font-size: 10px;

  &.prevMonthDay,
  &.flatpickr-disabled {
    color: #737d78 !important;
  }

  &.selected {
    background-color: #000000 !important;
    border: none;
  }
}

.flatpickr-monthDropdown-months,
.numInput.cur-year {
  color: #ffffff;
  font-size: 14px !important;
}

.flatpickr-current-month {
  display: flex !important;
  align-items: center;

  & > * + * {
    margin-left: 1rem !important;
  }
}

.vs__dropdown-toggle {
  border: 0;
  background-color: theme("colors.neutral.input");
  padding-top: 6px;
  padding-bottom: 6px;
}

.vs__dropdown-menu {
  background-color: theme("colors.neutral.input");
  color: #080606;
}

.vs__dropdown-option {
  color: theme("colors.widget-form-radio-label");
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-weight: 600;
  font-size: 0.875rem;

  &--highlight {
    background: none;
  }
}

.vs__selected-options .vs__selected {
  color: #ffffff;
}

.vs--single .vs__selected {
  color: theme("colors.widget-form-radio-label");
}

.vs__selected {
  background: theme("colors.active");
  color: theme("colors.widget-form-radio-label");
  font-weight: 600;
  font-size: 0.875rem;
}

.vs__search::placeholder {
  color: #737d78;
  font-size: 0.875rem;
}

.luggage_label {
  margin-top: 10px;
  margin-left: 15px;
  margin-right: 50px;
}

.row_div {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  margin: 5px 15px;
}

.luggage_section {
  padding: 10px 0;
  margin-top: 10px;
}

.dark-text {
  color: #a0afc0;
  font-weight: 500;
}

.luggage-toggle {
  height: 100%;
  margin-top: 15px;
  display: flex;
  flex-flow: row;
}

.inner-divs {
  height: 50%;
}

.luggage-config-group {
  width: 100%;
  justify-content: space-between;
  margin: auto;
}

.luggage-quantity {
  color: black;
  padding-left: 7%;
  width: 30%;
  height: 40px;
  border-radius: 5px;
  outline: none;
  font-size: 15px;
}

.luggage-action {
  background-color: #01e069;
  width: 16%;
  font-size: 20px;
  cursor: pointer;
}
.find_btn {
  margin-top: 20%;
}
.comp_link {
  margin-top: 10%;
  margin: auto;
  padding-bottom: 5%;
  text-align: center;
  padding-top: 5%;
}
.placeholderstyle::placeholder {
  font-size: 20px;
}
.catalogue-wallet {
  margin-top: 3%;
}
.sub_label {
  color: #ffffff;
}
.text-widget-form-radio-label {
  margin-top: 5px;
}
.my-2 {
  position: relative;
}
.grey-chevron {
  color: rgba(60, 60, 60, 0.5);
}
</style>

<style lang="scss" scoped>
.flatpickr-input {
  &::placeholder {
    font-weight: normal;
    color: #737d78;
  }
}
</style>
